import {
  Button,
  ButtonProps,
  createStyles,
  darken,
  lighten,
  makeStyles,
} from '@material-ui/core';
import cn from 'classnames';
import * as React from 'react';
import { TranquiTheme } from '../../containers/App/theme';

// type oldColors = 'blue'|'blueGradient'|'blueGreenGradient'|'green';
type NewColors = 'primary' | 'secondary';

type BtnProps = Omit<ButtonProps<React.ElementType>, 'color' | 'variant'> & {
  className?: string;
  color?: NewColors;
  variant?: 'contained' | 'outlined' | 'text';
  shadow?: boolean;
  target?: any;
};

const Btn: React.FC<BtnProps> = ({
  className,
  children,
  shadow,
  color = 'primary',
  variant = 'contained',
  ...rest
}) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <Button
      className={cn(
        classes.root,
        (classes as any)[`${variant}_${color}`],
        (classes as any)[`${variant}_defaultBtn`],
        shadow && (classes as any)[`shadow_${color}`],
        className,
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children}
    </Button>
  );
};

export default Btn;

const useStyles = makeStyles((theme: TranquiTheme) => {
  return createStyles({
    root: {
      '&.Mui-disabled': {
        background: '#C4C9D9',
        color: '#AAAFBF',
        textShadow: 'none',
      },
    },
    contained_defaultBtn: {
      fontSize: '0.875rem',
      lineHeight: 1,
      fontWeight: 600,
      letterSpacing: 1.1,
      padding: '0.6rem',
      boxSizing: 'border-box',
      cursor: 'pointer',
      textTransform: 'uppercase',
    },
    contained_primary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.pearl.main,
      '&:hover': {
        backgroundColor: darken(theme.palette.primary.main, 0.1),
      },
      '&:disabled': {
        cursor: 'none',
        opacity: 0.7,
        filter: 'grayscale(0.7)',
        color: darken(theme.palette.pearl.main, 0.1),
      },
    },
    contained_secondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.pearl.main,
      '&:hover': {
        backgroundColor: darken(theme.palette.secondary.main, 0.1),
      },
      '&:disabled': {
        cursor: 'none',
        opacity: 0.7,
        filter: 'grayscale(0.7)',
        color: darken(theme.palette.pearl.main, 0.1),
      },
    },
    outlined_defaultBtn: {
      fontSize: '0.875rem',
      lineHeight: 1,
      fontWeight: 600,
      letterSpacing: 1.1,
      padding: '0.6rem',
      boxSizing: 'border-box',
      cursor: 'pointer',
      border: 'solid 1px',
      textTransform: 'uppercase',
    },
    outlined_primary: {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      backgroundColor: lighten(theme.palette.primary.main, 0.95),
      '&:hover': {
        backgroundColor: lighten(theme.palette.primary.main, 0.85),
      },
      '&:disabled': {
        cursor: 'none',
        opacity: 0.7,
        filter: 'grayscale(0.7)',
        color: darken(theme.palette.primary.main, 0.1),
      },
    },
    outlined_secondary: {
      borderColor: theme.palette.secondary.main,
      color: theme.palette.secondary.main,
      backgroundColor: lighten(theme.palette.secondary.main, 0.95),
      '&:hover': {
        backgroundColor: lighten(theme.palette.secondary.main, 0.85),
      },
      '&:disabled': {
        cursor: 'none',
        opacity: 0.7,
        filter: 'grayscale(0.7)',
        color: darken(theme.palette.secondary.main, 0.1),
      },
    },
    text_defaultBtn: {
      fontSize: '0.875rem',
      lineHeight: 1,
      fontWeight: 400,
      letterSpacing: 0,
      padding: '0.6rem',
      boxSizing: 'border-box',
      cursor: 'pointer',
      textTransform: 'initial',
    },
    text_primary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: lighten(theme.palette.primary.main, 0.85),
      },
      '&:disabled': {
        cursor: 'none',
        opacity: 0.7,
        filter: 'grayscale(0.7)',
        color: darken(theme.palette.primary.main, 0.1),
      },
    },
    text_secondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: lighten(theme.palette.secondary.main, 0.85),
      },
      '&:disabled': {
        cursor: 'none',
        opacity: 0.7,
        filter: 'grayscale(0.7)',
        color: darken(theme.palette.secondary.main, 0.1),
      },
    },
  });
});
